var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStepDeleteIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.8585 27.4526C10.0156 27.4526 9.28972 27.1522 8.68101 26.5513C8.0723 25.9505 7.76795 25.234 7.76795 24.4018V8.48172H7.35993C6.9681 8.45176 6.64348 8.29507 6.38607 8.01166C6.12869 7.72828 6 7.38884 6 6.99334C6 6.56299 6.14875 6.20089 6.44625 5.90703C6.74378 5.61318 7.11013 5.46625 7.54531 5.46625H12.933V4.91662C12.9526 4.50117 13.1078 4.15331 13.3988 3.87304C13.6898 3.59277 14.0486 3.45264 14.4751 3.45264H17.5281C17.9498 3.45264 18.3073 3.59389 18.6008 3.87638C18.8942 4.15888 19.0507 4.50683 19.0702 4.92024V5.46625H24.4482C24.8828 5.46625 25.2501 5.61475 25.5501 5.91174C25.85 6.20874 26 6.57241 26 7.00276C26 7.39826 25.8702 7.73613 25.6106 8.01638C25.3511 8.29664 25.0275 8.45176 24.64 8.48172H24.2321V24.4018C24.2321 25.234 23.9271 25.9505 23.3171 26.5513C22.7071 27.1522 21.9797 27.4526 21.1349 27.4526H10.8585Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStepDeleteIcon);
export default __webpack_public_path__ + "static/media/stepDeleteIcon.b2948f77.svg";
export { ForwardRef as ReactComponent };